import { useContext, useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { useHistory } from 'react-router-dom';

export default function RouteWrapper({
  component: Component,
  isPrivate,
  ...rest
}) {
  const { signed, loading, user, verificaToken } = useContext(AuthContext);

  useEffect(() => {
    if (!signed) {
      const userTemp = JSON.parse(localStorage.getItem("user"));
      if (userTemp != null) {      
        verificaToken(userTemp);
      }
    }
  }, [signed, verificaToken]);

  if (loading) {
    return (
      <div> Carregando..... </div>
    )
  }

  if (!signed && isPrivate) {
    return <Redirect to="/" />
  }

  if (signed && !isPrivate) {
    if (user.perfilUser.includes('user-admin')) {
      localStorage.setItem("user", JSON.stringify(user));
      const route = localStorage.getItem('route');
      return <Redirect to={route} />
    } else {
      return <Redirect to="/" />
    }
  }

  return (
    <Route
      {...rest}
      render={props => (
        <Component {...props} />
      )}
    />
  )
}